var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8748 0H3.54142C1.58642 0 -0.000244141 1.58667 -0.000244141 3.54167V27.625C-0.000244141 29.58 1.58642 31.1667 3.54142 31.1667H14.8748C16.8298 31.1667 18.4164 29.58 18.4164 27.625V3.54167C18.4164 1.58667 16.8298 0 14.8748 0ZM9.20809 29.75C8.03226 29.75 7.08309 28.8008 7.08309 27.625C7.08309 26.4492 8.03226 25.5 9.20809 25.5C10.3839 25.5 11.3331 26.4492 11.3331 27.625C11.3331 28.8008 10.3839 29.75 9.20809 29.75ZM15.5831 24.0833H2.83309V4.25H15.5831V24.0833Z",
    fill: "#217C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.3be7e0209ba4027495bd02ae6f482b5f.svg";
export { ForwardRef as ReactComponent };